<template>
  <section>
    <v-card class="p-p-0 p-pl-lg-3 p-mb-5" flat>
      <v-layout mb-3 align-start justify-space-between row>
        <v-toolbar-title>Archivos</v-toolbar-title>
        <Button
          label="Agregar"
          type="primary"
          icon="pi pi-plus"
          @click="openDialog()"
        />
      </v-layout>
      <DataTable :value="files" :autoLayout="true">
        <Column field="nombre" header="Nombre" />
        <Column field="file_type_name" header="Tipo de Archivo" />
        <Column>
          <template #header>
            <div class="text-right">
              Acciones
            </div>
          </template>
          <template #body="slotProps">
            <div class="text-right">
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="confirmDelete(slotProps.data.id)"
                v-tooltip.top="'Eliminar'"
              />
            </div>
          </template>
        </Column>
        <template #empty>
          No hay archivos registrados.
        </template>
      </DataTable>
    </v-card>
    <Dialog
      :visible.sync="showDialog"
      :style="{ width: '450px' }"
      header="Agregar Archivo"
      :modal="true"
      class="p-fluid"
    >
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit(submitForm)">
          <base-input
            v-model="archive.nombre"
            rules="required|min:3"
            label="Nombre"
            name="Nombre"
            type="text"
          />
          <base-input-select
            v-model="archive.tipo"
            :options="fileTypes"
            optionValue="file_type_id"
            optionLabel="file_type_name"
            label="Tipo de Archivo"
            name="Tipo de Archivo"
          />
          <div
            v-if="archive.tipo"
            class="p-fileupload p-fileupload-basic p-component p-mb-4"
          >
            <input
              ref="file"
              type="file"
              class="custom-file-input"
              :accept="accept"
              v-on:change="handleFileUpload()"
            />
          </div>
          <div class="p-d-flex">
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text mx-2"
              type="button"
              @click="showDialog = false"
            />
            <Button
              class="mx-2"
              label="Guardar"
              icon="pi pi-check"
              type="submit"
            />
          </div>
        </form>
      </ValidationObserver>
    </Dialog>
  </section>
</template>

<script>
import archiveService from "@/services/axios/archives.service";
import { getArchivoLessonService } from "@/services/GetArchivoLesson.service";
export default {
  props: ["files", "lessonId"],
  data() {
    return {
      showDialog: false,
      file: null,
      fileTypes: [],
      archive: {
        nombre: "",
        tipo: ""
      }
    };
  },
  computed: {
    accept() {
      const type = this.fileTypes.find(type => this.archive.tipo === type.file_type_id);
      return type ? type.file_type_rules : "";
    }
  },
  mounted() {
    this.loadTipoArchivo();
  },
  methods: {
    loadTipoArchivo() {
      archiveService.getFileTypes().then(({ data }) => {
        this.fileTypes = data;
      });
    },
    openDialog() {
      this.file = {};
      this.showDialog = true;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    submitForm() {
      var formData = new FormData();
      formData.append("file", this.file);
      formData.append("nombre", this.archive.nombre);
      formData.append("tipo_archivo_id", this.archive.tipo);
      formData.append("lesson_id", this.lessonId);
      archiveService
        .save(formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          ({ data }) => {
            this.showDialog = false;
            this.$emit("setData", data);
            this.$swal({
              text: "Archivo creado con éxito",
              icon: "success",
            });
          },
          error => {
            this.$swal({
              title: 'Error',
              text: error.response.data.error,
              icon: "error"
            });
          }
        );
    },
    confirmDelete(id) {
      this.$confirm.require({
        message: "¿Estás seguro de realizar esta acción?",
        header: "Confirmación",
        icon: "pi pi-info-circle",
        acceptLabel: "Si",
        acceptClass: "p-button-danger",
        accept: () => this.deleteArchivo(id),
        reject: () => {}
      });
    },
    deleteArchivo(id) {
      archiveService.delete(id).then(
        ({ data }) => {
          this.$emit("setData", data);
          this.$swal({
            text: "Archivo eliminado con éxito",
            icon: "success",
          });
        },
        (error) => {
          this.$swal({
            icon: "error",
            title: 'Error',
            text: error.response.data.error
          });
        }
      );
    },
    descargarArchivo(ruta) {
      getArchivoLessonService.getById(ruta).then(data => {
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Leccion/Archives.vue